module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av698-89962350a092fe02d2ccd09340884ed0.jpg";